import { useCookieConsent } from "@/hooks/useCookieConsent";

export default function CookieBanner() {
  const { showBanner, acceptAll, acceptFunctionalOnly, openModal } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] animate-slide-up hidden md:block"
      role="dialog"
      aria-modal="true"
      aria-label="Cookie toestemming"
    >
      <div className="bg-brand-text border-t-2 border-brand-yellow">
        <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-4 md:py-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-5">
            {/* Text */}
            <div className="flex-1 max-w-2xl">
              <p className="font-geist font-semibold text-sm md:text-base text-white mb-1.5 md:mb-2">
                Wij gebruiken cookies
              </p>
              <p className="font-geist text-xs md:text-sm text-white/70 leading-relaxed">
                Functionele cookies zijn nodig voor de werking van de website. Voor analytische en marketing cookies vragen wij uw toestemming.{" "}
                <a
                  href="/cookiebeleid/"
                  className="text-brand-yellow underline underline-offset-2 hover:text-white transition-colors"
                >
                  Meer info
                </a>
              </p>
            </div>

            {/* Buttons */}
            <div className="flex flex-row items-center gap-2 md:gap-3 shrink-0">
              <button
                type="button"
                onClick={acceptAll}
                className="bg-brand-yellow text-brand-text font-geist font-semibold text-xs md:text-sm px-4 md:px-5 py-3 md:py-3 rounded-md hover:bg-brand-yellow/90 transition-colors whitespace-nowrap cursor-pointer min-h-11"
                aria-label="Accepteer alle cookies"
              >
                Alles accepteren
              </button>
              <button
                type="button"
                onClick={acceptFunctionalOnly}
                className="border border-white/40 text-white font-geist font-medium text-xs md:text-sm px-4 md:px-5 py-3 md:py-3 rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer min-h-11"
                aria-label="Accepteer alleen functionele cookies"
              >
                Alleen functioneel
              </button>
              <button
                type="button"
                onClick={openModal}
                className="text-white/60 font-geist text-xs md:text-sm underline underline-offset-2 hover:text-white transition-colors whitespace-nowrap cursor-pointer min-h-11 px-2"
                aria-label="Open cookievoorkeuren"
              >
                Voorkeuren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}